import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';

const OrgManualNotification = () => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  

  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          setError('No authentication token found');
          setLoading(false);
          return;
        }

        const response = await axios.get('https://api.safree.org/api-v2022/organization/auth/v1/organizationUsers', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          setUsers(response.data.data);
        } else {
          setError('Failed to fetch users');
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('An error occurred while fetching users: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const totalPages = Math.ceil(users.length / rowsPerPage);
  const currentRows = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5; 
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleSelectUser = (userId) => {
    setSelectedUsers((prevSelected) => {
      if (prevSelected.includes(userId)) {
        return prevSelected.filter((id) => id !== userId);
      } else {
        return [...prevSelected, userId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedUsers.length === users.length) {
      setSelectedUsers([]); 
    } else {
      setSelectedUsers(users.map((user) => user.userId)); 
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedUsers.length === 0) {
      alert('Please select at least one user.');
      return;
  }

    try {
      setIsSubmitting(true);
      const token = localStorage.getItem('token');

      if (!token) {
        setError('No authentication token found');
        return;
      }

      const response = await axios.post(
        'https://api.safree.org/api-v2022/organization/auth/v1/send-manual-notification',
        {
          title,
          message,
          userIds: selectedUsers,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setTitle('');
        setMessage('');
        setSelectedUsers([]);
        setError(null);
        alert('Notification sent successfully!');
      } else {
        setError('Failed to send notification');
      }
    } catch (err) {
      console.error('Error sending notification:', err);
      setError('An error occurred while sending notification: ' + err.message);
    }finally {
      setIsSubmitting(false); // Stop loading after request finishes
    }
  };

  if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-12">
          <p className="sub-heading">Manual Notification</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <div className="form-container">
            <form className="styled-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="title">Enter Your Title</label>
                <input
                  type="text"
                  id="title"
                  className="form-control"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Enter Your Message</label>
                <textarea
                  id="description"
                  className="form-control"
                  placeholder="Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
              <button type="submit" className="btn btn-submit">
              {isSubmitting ? (
                  <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status">
                  </div>
                ) : (
                  'Create'
                )}
                </button>
            </form>
          </div>
        </div>

        <div className="col-md-8">
          <div className="table-container tblmnual">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectedUsers.length === users.length}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>S. No</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                </tr>
              </thead>
              <tbody>
                {currentRows.map((user, index) => (
                  <tr key={user.userId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(user.userId)}
                        onChange={() => handleSelectUser(user.userId)}
                      />
                    </td>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.phoneNumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="pagination-container">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('prev')}
                disabled={currentPage === 1}
              >
                &laquo; Prev
              </button>
              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('next')}
                disabled={currentPage === totalPages}
              >
                Next &raquo;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgManualNotification;
